import React, {Fragment, useState} from "react";

import {GridToolbar} from "@progress/kendo-react-grid";
import {tableConfig, detailConfig} from "./tableConfig";

// components
import OrderMassiveActions from "./OrderMassiveActions";
import NestedTable from "../../../Common/Orders/NestedTable";
import BasicTable from "../../../Common/Orders/BasicTable";
import {Order} from "../../../../types/orders/order";

interface Props {
  tableData: Order[];
  fetchingOrders: boolean;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  activeFilters: any
  featuresAllowed: string[];
}

export default (props: Props) => {
  const initialSortValue = [
    { field: null, dir: null },
  ];
  const [sort, setSort] = useState(initialSortValue);
  const [featuresAllowed, setFeaturesAllowed] = React.useState<string[]>(props.featuresAllowed);
  
  const orderDetail = (props: any) => {
    const data = props.dataItem.detail;
    return (
      <BasicTable
        tableConfig={detailConfig('CÓDIGO ART')}
        parentData={props.dataItem}
        tableData={data}
        loading={false}
        featuresAllowed={featuresAllowed}
      />
    );
  };

  return (
      <Fragment>
        <GridToolbar>
          <OrderMassiveActions
              orders={props.tableData}
              requestNewPage={props.sendFilters}
          />
        </GridToolbar>
        <NestedTable
            tableConfig={tableConfig('ID AXUM')}
            tableData={props.tableData}
            loading={props.fetchingOrders}
            detailComponent={orderDetail}
            requestNewPage={props.sendFilters}
            take={props.take}
            skip={props.skip}
            total={props.total}
            sort={sort}
            setSort={setSort}
            featuresAllowed={props.featuresAllowed}
        />
      </Fragment>
  );
};
